import { enumParser } from '#validation/common/parsers';
import { WorkspaceStatus } from '../constants';
export const workspaceStatusParser = enumParser(WorkspaceStatus);
